import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useLanguage } from '../../../context/language';
import SelectBank from '../../Banks';
import ShowFieldGroup from '../../ShowFieldGroup';
import { getStrLang } from '../../Translate';
import { getAceiteTermos } from '../../../api/fastcoinService';
import { Modal, Button } from 'react-bootstrap';

const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
}));

const Ted = (props) => {
    //Chamada para as variáveis e funções do Context
    const { translate, lang, orderFromDeposit, setBankSelected, bankSelected} = useLanguage();
    //StyledComponent do Form
    const classes = useStyles();
    //Capturando parâmetros da URL /deposit
    let order_number = sessionStorage.getItem("order_no");
    //Hooks
    const country = sessionStorage.getItem("country").toLocaleLowerCase();

    //Controle do modal
    const [show, setShow] = useState(sessionStorage.getItem("popup_ted") === "false" ? false : true);
    const [bankOptions, setbankOptions] = useState(formatarCnpj(JSON.parse(sessionStorage.getItem("bank_info"))));
    const handleClose = () => {
        sessionStorage.setItem("popup_ted", "false");
        setShow(false)
    };
    
    function formatarCnpj(banks) {
        for (let i = 0 ; banks && i < banks.length ; i++) {
            banks[i].account = (banks[i].account.length === 5 ?
                (banks[i].account).replace(/^(\d{2})(\d{2})(\d{1})/, "$1$2-$3") :
                banks[i].account.length === 7 ? (banks[i].account).replace(/^(\d{2})(\d{2})(\d{2})(\d{1})/, "$1$2$3-$4") :
                    banks[i].account.length === 8 ? (banks[i].account).replace(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{1})/, "$1$2$3$4-$5") :
                        banks[i].account.length === 9 ? (banks[i].account).replace(/^(\d{2})(\d{2})(\d{2})(\d{2})(\d{1})/, "$1$2$3$4-$5") :
                            banks[i].account.length === 10 ? (banks[i].account).replace(/^(\d{2})(\d{2})(\d{2})(\d{2})(\d{1})(\d{1})/, "$1$2$3$4$5-$6") :
                                banks[i].account);
            banks[i].document = (banks[i].document.length === 14 ? (banks[i].document).replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5") : banks[i].document.length === 11 ? (banks[i].document).replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4") : banks[i].document);
        }
        return banks;
    }

    //valida se os termos da ordem foram aceitos
    useEffect(() => {
        function validarTermos() {
            getAceiteTermos(sessionStorage.getItem("order_no"))
                .then(res => {
                    //console.log(res);
                    if (res !== undefined) {
                        props.setShowTermos(false);
                    } else {
                        props.setShowTermos(true);
                    }
                    translate();
                })
                .catch(err => {
                    if (err.error.includes("Could not find")) {
                        console.log(err);
                    } else {
                        console.log(err);
                        alert("Please talk with the administrator");
                    }
                    props.setShowTermos(true);
                })
        }
        if (orderFromDeposit !== "") {
            validarTermos();
            let options = JSON.parse(sessionStorage.getItem("bank_info"));
            setbankOptions(formatarCnpj(options));    
            SelectBank(bankOptions, props.selectedBank);
            setBankSelected(props.selectedBank);
        }
    }, []);

    //Retorna quais bancos estão disponíveis para o país desejado
    //As informações dos bancos, ficam no Componente ../Banks

    //Traduz o texto na tela quando mudado o idioma pelo usuário ou quando muda o banco
    useEffect(() => {
        translate();
        formatarCnpj();        
    }, [translate, country]);

    //Escolhendo um banco diferente
    //verificar como vai ficar quando tiver mais bancos

    const handleChangeBank = (event) => {
        SelectBank(bankOptions, event);
        setBankSelected(event);
    };

    console.log(bankSelected === undefined ? bankOptions?.filter(item => item.bank_name === bankSelected)[0].bank_name : bankSelected);
 
    return (
       
        <div className="form-ted">            
            <Modal show={show} onHide={handleClose} aria-labelledby="contained-modal-title-vcenter" centered>
                <Modal.Header closeButton>
                    <Modal.Title>{getStrLang(lang.nameLang, "aviso_aba_ted_titulo")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{getStrLang(lang.nameLang, "aviso_aba_ted_mensagem")}</Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handleClose}>
                        {getStrLang(lang.nameLang, "aviso_aba_ted_close")}
                    </Button>
                </Modal.Footer>
            </Modal>           
            <ShowFieldGroup country={country} />
            <br />
            <p className="center"><b>{getStrLang(lang.nameLang, "msg5_TED1") + " "}<span className="destaque-order">{order_number}</span> {" " + getStrLang(lang.nameLang, "msg5_TED2")}</b></p>
        </div>
    )
}

export default Ted;